import React from 'react';
import { Line } from 'react-chartjs-2';

const ForecastChart = () => {
  const data = {
    labels: ['2020', '2021', '2022', '2023', '2024(F)'],
    datasets: [{
      label: 'Annual Throughput (Million Tons)',
      data: [1.65, 1.92, 2.02, 2.18, 2.45],
      backgroundColor: 'rgba(77, 166, 255, 0.1)',
      borderColor: '#4da6ff',
      borderWidth: 3,
      fill: true,
      tension: 0.4
    }]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: false,
        title: {
          display: true,
          text: 'Million Tons'
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        }
      },
      x: {
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        }
      }
    },
    plugins: {
      legend: {
        position: 'top',
      }
    }
  };

  return <Line data={data} options={options} />;
};

export default ForecastChart;